import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { formatAttributeValue, pluralize } from "../../utils/stringFunctions";
import APILoader from "../../components/APILoader";
import { useNavigationBar } from "../../context/NavigationContext";
import { fetchArtifactReports } from "../../api/artifacts/atrifactService";
import { SKContentReport } from "../../models/SKArtifact";
import { CreateArtifactContext } from "../../context/CreateArtifactContext";

type SKContentReportKey = keyof SKContentReport;

const ContentReports = () => {
  const { id } = useParams();
  const { contentData } = useContext(CreateArtifactContext);
  const { setNavProps } = useNavigationBar();
  const navigate = useNavigate();
  const [reports, setReports] = useState<SKContentReport[] | undefined>(undefined);

  const getFormattedValue = (data: SKContentReport, key: SKContentReportKey) => {
    switch (key) {
      case "reportedDate":
        return formatAttributeValue(data[key]);
      default:
        return formatAttributeValue(data[key]);
    }
  };

  useEffect(() => {
    setNavProps({
      backArrow: false,
      title: "Content Reports",
      subtitle: pluralize(contentData.reportCount ?? 0, "Report"),
      buttonTitle: "Close",
      enableLink: false,
      onNext: () => {
        // navigate(1);
      },
      onClose: () => {
        navigate(-1);
      },
    });
  }, [contentData, navigate, setNavProps]);

  useEffect(() => {
    const fetchReports = async (id: string) => {
      try {
        const statusList = await fetchArtifactReports(id, 10);
        console.log(JSON.stringify(statusList));
        setReports(statusList.docs);
      } catch (error) {
        throw new Error("Invalid feedback type");
      }
    };
    if (id) {
      fetchReports(id);
    }
  }, [id]);

  return reports ? (
    <div className="flex flex-col gap-[30px] text-sm">
      {reports.map((report, index) => (
        <div key={index} className="flex flex-col gap-[6px] mt-[15px] ">
          <div className="relative w-full">
            <div className="flex items-center justify-start w-full gap-4">
              <div>
                <p className="items-center">{getFormattedValue(report, "reportedDate")}</p>
              </div>
            </div>
          </div>
          <div className="relative w-full">
            <div className="flex items-center justify-start w-full gap-4">
              <div>
                <p className="text-base font-bold capitalize">{report.type ?? "--"}</p>
              </div>
            </div>
          </div>
          <div className="relative w-full">
            <div className="flex items-center justify-start w-full gap-4">
              <div>
                <p className="pb-1 font-normal ">{report.message ?? "--"}</p>
              </div>
            </div>
          </div>
          <div className="relative w-full">
            <div className="flex items-center justify-start w-full gap-1">
              <div>
                <p className="items-center">Report ID:</p>
              </div>
              <div>
                <p className="items-center font-bold">{report?.reportID ?? "--"}</p>
              </div>
            </div>
          </div>
          <div className="relative w-full">
            <div className="flex items-center justify-start w-full gap-1">
              <div>
                <p className="items-center">User ID:</p>
              </div>
              <div>
                <p className="items-center font-bold">{report?.userID ?? "--"}</p>
              </div>
            </div>
          </div>
          <div className="relative w-full">
            <div className="flex items-center justify-start w-full gap-1">
              <div>
                <p className="items-center">User Phone:</p>
              </div>
              <div>
                <p className="items-center font-bold">{report?.phone ?? "--"}</p>
              </div>
            </div>
          </div>
          <div className="relative w-full">
            <div className="flex items-center justify-start w-full gap-1">
              <div>
                <p className="items-center">OS Version:</p>
              </div>
              <div>
                <p className="items-center font-bold">{`${report?.osType ?? "--"} ${report?.osVersion ?? "--"}`}</p>
              </div>
            </div>
          </div>
          <div className="relative w-full gap-3">
            <div className="flex items-center justify-start w-full gap-1">
              <div>
                <p className="items-center">App Version:</p>
              </div>
              <div>
                <p className="items-center font-bold">{report?.appVersion ?? "--"}</p>
              </div>
            </div>
            <div className="thinseparator mt-[10px]" />
          </div>
        </div>
      ))}
    </div>
  ) : (
    <>
      <APILoader loading={true} />
    </>
  );
};

export default ContentReports;
